/**
 * The box categories the store offers on its boxes page, from the resolved config. Which boxes
 * are in one comes on each box (`BoxSummary.categories`), so the page shows only the categories a
 * listed box is in.
 */
import { type BoxCategory, isBoxCategory, sortBoxCategories } from "@loot-os/api-contract";

import type { TenantConfig } from "./tenant.js";

/**
 * Fail-safe read: a config cached by an older BFF or in sessionStorage has no `boxCategories`,
 * and reads as none; a code this build does not know is dropped.
 */
export function boxCategoriesOf(config: TenantConfig): BoxCategory[] {
  const value = (config as Partial<TenantConfig>).boxCategories;
  return Array.isArray(value) ? sortBoxCategories(value.filter(isBoxCategory)) : [];
}
